import { nextApiAxios } from "../../services/endpoints/core/appAxiosService";
import { LeadService } from "../../services/v2/leads";
import { _DispathSaveHookLead } from "../../services/v2/leads/_DispathSaveHookLead";

export async function getLead(context = null) {
  if (typeof window !== "undefined") {
    // Client
    const dataLead = await nextApiAxios
      .get("/leads")
      .then((data) => data.data)
      .catch((err) => false);
    return dataLead;
  }

  // Server
  if (!context?.req) {
    return null;
  }

  const ls = new LeadService(context?.req, context?.res);
  const lead = await ls.find();

  return {
    data: lead,
  };
}

export async function getLeadById({ id, context }) {
  if (typeof window !== "undefined") {
    throw Error("Apenas serverside");
  }

  // Server
  const ls = new LeadService(context?.req, context?.res);
  const lead = await ls.find(parseInt(id));

  return {
    data: lead,
  };
}

export async function getLeadByEmail({ email, context }) {
  if (typeof window !== "undefined") {
    throw Error("Apenas serverside");
  }

  // Server
  const ls = new LeadService(context?.req, context?.res);
  const lead = await ls.findByEmail(email);
  return {
    data: lead,
  };
}

export async function saveLead(data, context = null) {
  if (typeof window !== "undefined") {
    // Client
    const resultSavedLead = await nextApiAxios.post("/leads", data);
    return resultSavedLead.data;
  }

  // Server

  if (!context?.req) {
    return null;
  }

  const ls = new LeadService(context.req, context.res);
  const resultSaveLead = await ls.save(data);

  return resultSaveLead;
}

export async function saveLeadInHook(data, context = null) {
  if (typeof window !== "undefined") {
    // Client
    return await nextApiAxios
      .post("/hook-lead", data)
      .then((data) => data.data)
      .catch((err) => err.message);
  }

  const lead = await getLead(context);

  if (!lead.data) {
    return false;
  }
  delete lead?.data?.attributes?.usina;
  const ls = new LeadService(context.req, context.res);

  const resultSaveLead = await ls.dispathSaveHookLead({
    ...data,
    pipe_id: lead?.data?.attributes?.pipe_id,
    id: lead?.data?.id,
    json_form: lead.data,
  });
  return resultSaveLead;
}
